export default __webpack_public_path__ + "static/media/mobile_image_login.c803de37.svg";